import React, { FunctionComponent, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type ArrowIconProps = TestID & {
    /** possible themed backgroundColors
     *
     * @defaultValue onyx-opacity-70
     * */
    backgroundColor?: 'onyx-opacity-12' | 'onyx-opacity-70' | 'pearl' | 'pearl-opacity-70'
    /** possible themed font colors
     *
     * @defaultValue pearl
     * */
    color?: 'pearl' | 'onyx' | 'WHITE'
    /** arrow icon type */
    icon: 'scroll-left' | 'scroll-right'
    /**
     * don't do the breakpoint's dance if given and just use mobile
     * */
    forceMobileView?: boolean
    /** the callback when the user presses on the arrow icon
     *
     * @TJS-type function
     * */
    onPress: () => void
}

const ArrowIcon: FunctionComponent<ArrowIconProps> = ({
    backgroundColor = 'onyx-opacity-70',
    color = 'WHITE',
    forceMobileView,
    icon,
    onPress,
    testID,
}): ReactElement => {
    const size = forceMobileView ? 32 : [32, 32, 40]
    const borderRadius = forceMobileView ? 16 : [16, 16, 20]
    const fontSize = forceMobileView ? 12 : [12, 12, 16]
    const lineHeight = forceMobileView ? '14px' : ['14px', '14px', '18px']

    return (
        <Touchable onPress={onPress}>
            <Grid
                noExpand
                center
                width={size}
                height={size}
                borderRadius={borderRadius}
                backgroundColor={backgroundColor}
                testID={testID}
            >
                <FontelloIcon
                    name={icon}
                    textAlign="center"
                    paddingLeft={icon === 'scroll-left' ? 0 : 1}
                    paddingRight={icon === 'scroll-left' ? 1 : 0}
                    color={color}
                    fontSize={fontSize}
                    lineHeight={lineHeight}
                />
            </Grid>
        </Touchable>
    )
}

export default ArrowIcon
